import styled from "styled-components";

const PageContainer = styled.section`
    margin-bottom: 30px;
`;

const PerPageContainer = styled.section`
    margin-top: 30px;
    margin-bottom: 30px;
    .per-page-container-inner {
    }
`;

export { PageContainer, PerPageContainer };
